import { render, staticRenderFns } from "./VideoGallery.vue?vue&type=template&id=beecde66&scoped=true&"
import script from "./VideoGallery.vue?vue&type=script&lang=js&"
export * from "./VideoGallery.vue?vue&type=script&lang=js&"
import style0 from "./VideoGallery.vue?vue&type=style&index=0&id=beecde66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beecde66",
  null
  
)

component.options.__file = "VideoGallery.vue"
export default component.exports